<div class="container mt-3">
   <form class="form-modal" [formGroup]="frmGrpEsUser" autocomplete="off">
      <div class="grid grid-cols-12 gap-4 pb-4">
         <div class="col-span-6 lg:col-span-6">
            <mat-label>Nome</mat-label>
            <mat-form-field class="w-full" appearance="fill">
               <input matInput type="text" formControlName="first_name">
               <mat-error *ngIf="frmGrpEsUser.get('nome')?.hasError('required')">
                  Nome obbligatorio
               </mat-error>
            </mat-form-field>
         </div>

         <div class="col-span-6 lg:col-span-6">
            <mat-label>Cognome</mat-label>
            <mat-form-field class="w-full" appearance="fill">
               <input matInput type="text" formControlName="last_name">
               <mat-error *ngIf="frmGrpEsUser.get('cognome')?.hasError('required')">
                  Cognome obbligatorio
               </mat-error>
            </mat-form-field>
         </div>

         <div class="col-span-6 lg:col-span-12">
            <mat-label>Email</mat-label>
            <mat-form-field class="w-full" appearance="fill">
               <input matInput type="text" formControlName="email">
               <mat-error *ngIf="frmGrpEsUser.get('email')?.hasError('required')">
                  Email obbligatoria
               </mat-error>
            </mat-form-field>
         </div>

<!--         <div class="col-span-6 lg:col-span-6">-->
<!--            <mat-label>Username *</mat-label>-->
<!--            <mat-form-field class="w-full" appearance="fill">-->
<!--               <input matInput type="text" formControlName="username">-->
<!--               <mat-error *ngIf="frmGrpEsUser.get('username')?.hasError('required')">-->
<!--                  Username obbligatorio-->
<!--               </mat-error>-->
<!--            </mat-form-field>-->
<!--         </div>-->

<!--         <div class="col-span-6 lg:col-span-4">-->
<!--            <mat-label>Password *</mat-label>-->
<!--            <mat-form-field class="w-full" appearance="fill">-->
<!--               <input matInput type="text" formControlName="password">-->
<!--               <mat-error *ngIf="frmGrpEsUser.get('password')?.hasError('required')">-->
<!--                  Password obbligatoria-->
<!--               </mat-error>-->
<!--            </mat-form-field>-->
<!--         </div>-->

<!--         <div class="col-span-6 lg:col-span-4">-->
<!--            <mat-label>Ripeti Password *</mat-label>-->
<!--            <mat-form-field class="w-full" appearance="fill">-->
<!--               <input matInput type="text" formControlName="ripeti_password">-->
<!--               <mat-error *ngIf="frmGrpEsUser.controls['ripeti_password'].pristine ||-->
<!--                                 frmGrpEsUser.controls['ripeti_password'].errors?.MatchPassword">-->
<!--                  Le password non corrispondono-->
<!--               </mat-error>-->
<!--            </mat-form-field>-->
<!--         </div>-->
      </div>

      <h3 class="font-bold">Ruoli dell'Utente per Esercizio</h3>
      <div class="example-section mb-5">
         <div class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
            <div class="flex items-center" *ngFor="let ruolo of PVenditaUtente.PermessiEsercizioUser">
               <input id="radio_{{ruolo.value}}"
                      formControlName="ruolo_es"
                      [value]="ruolo.value"
                      type="radio" checked
                      [checked]="ruolo.value==frmGrpEsUser.get('ruolo_es')?.value"
                      class="h-4 w-4 border-gray-300 text-ibm-secondary-600 focus:ring-ibm-secondary">
               <label for="radio_{{ruolo.value}}" class="ml-2 block text-sm leading-6 text-gray-900">{{ruolo.display}}</label>
            </div>
         </div>
      </div>

      <hr class="my-10">

      <h3 class="font-bold">Ruoli dell'Utente per Punti Vendita / Magazzini</h3>
      <div *ngFor="let pv of permessiArray.controls; let i = index" formArrayName="permessi" class="mb-6">
         <h4 class="font-bold mb-0 text-ibm-secondary-400">Punto Vendita / Magazzino {{permessiArray.controls[i].get('nome_pv')?.value}}</h4>
         <div class="example-section mb-5">

            <div [formGroupName]="i">
               <div class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                  <div class="flex items-center" *ngFor="let ruolo of PVenditaUtente.PermessiPVenditaUser">
                     <input id="radio_{{ruolo.value}}{{i}}"
                            formControlName="ruolo"
                            [value]="ruolo.value"
                            type="radio" checked
                            [checked]="ruolo.value==permessiArray.controls[i].get('ruolo')?.value"
                            class="h-4 w-4 border-gray-300 text-ibm-secondary-600 focus:ring-ibm-secondary">
                     <label for="radio_{{ruolo.value}}{{i}}" class="ml-2 block text-sm leading-6 text-gray-900">{{ruolo.display}}</label>
                  </div>
               </div>
            </div>

         </div>
      </div>
   </form>

</div>
